module.exports = __webpack_public_path__ + "static/media/sandwich_white.129a5f45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sandwich_white.svg
// module id = 39
// module chunks = 0